import { isComponentReference } from '$lib/utilities/storyblok';

export function findNeededComponents(
  obj: unknown,
  neededComponents: Array<string> = [],
): Array<string> {
  if (typeof obj !== 'object' || obj === null) {
    return neededComponents;
  }

  if (isComponentReference(obj) && !neededComponents.includes(obj.component)) {
    neededComponents.push(obj.component);
  }

  for (const subObj of Object.values(obj)) {
    findNeededComponents(subObj, neededComponents);
  }

  return neededComponents;
}
